import { commonTranslationEN } from '@common/translations/en';

export const inviteStatusEN = {
  ...commonTranslationEN,
  'There no invites to display': 'There no invites to display',
  'Failed to load invites': 'Failed to load invites',
  'patient': 'patient',
  'New Invite': 'New Invite',
  'Open Questionnaire': 'Open Questionnaire',
  'Send Reminder': 'Send Reminder',
  'Update Status': 'Update Status',
  'View Invite History': 'View Invite History',
  'Unlock Invite': 'Unlock Invite',
  'Lock Invite': 'Lock Invite',
  'Open Pedigree': 'Open Pedigree',
  'Open Datasheet': 'Open Datasheet',
  'Generate Letter': 'Generate Letter',
  'Restore Columns to Default': 'Restore Columns to Default',
  'Failed to get status data': 'Failed to get status data',
  'Failed to update status': 'Failed to update status',
  'The Questionnaire reminder email was successfully sent': 'The Questionnaire reminder email was successfully sent',
  'The Questionnaire invitation emails were successfully submitted': 'The Questionnaire invitation emails were successfully submitted',
  'After locking this invite the patient will not be able to edit the questionnaire': 'After locking this invite the patient will not be able to edit the questionnaire',
  'Are you sure you want to lock this invite? You can unlock it again later if needed': 'Are you sure you want to lock this invite? You can unlock it again later if needed',
  'If you unlock this invite the patient will be able to access the questionnaire and modify data': 'If you unlock this invite the patient will be able to access the questionnaire and modify data',
  'Are you sure you want to unlock?': 'Are you sure you want to unlock?',
  'Failed to save lock/unlock invite': 'Failed to save lock/unlock invite',
  'Failed to restore column to default': 'Failed to restore column to default',
  'Failed to get invites': 'Failed to get invites',
  'Failed to get admin functions': 'Failed to get admin functions',
  'Failed to get filters': 'Failed to get filters',
  'Failed to get invites columns': 'Failed to get invites columns',
  'Launch New Questionnaire': 'Launch New Questionnaire',
  'Batch Letters': 'Batch Letters',
  'New Invites': 'New Invites',
  'Send Reminders': 'Send Reminders',
  'Unlock Invites': 'Unlock Invites',
  'Lock Invites': 'Lock Invites',
  'unlockInvitesMsg': 'If you unlock the invites the patients will be able to access the questionnaire and modify data. Are you sure you want to unlock?',
  'lockInvitesMsg': 'After locking the invites the patients will not be able to edit the questionnaire. Are you sure you want to lock the invites? You can unlock it again later if needed.',
  'invitesAreLockedToSendReminder': 'Some invite(s) are locked, unable to send reminders. Please unlock before attempting to send another reminders.',
  'inviteIsLockedToSendReminder': 'This invite is locked, unable to send reminder. Please unlock before attempting to send another reminder.',
  'The Questionnaire reminder emails were successfully sent': 'The Questionnaire reminder emails were successfully sent',
  'Select a Questionnaire you want to invite patients to': 'Select a Questionnaire you want to invite patients to',
  'New Patient': 'New Patient',
  'Existing patient or relative': 'Existing patient or relative',
  'Members of one family': 'Members of one family',
  'Individual': 'Individual',
  'Patients who meet specific criteria': 'Patients who meet specific criteria',
  'Who would you like to invite?': 'Who would you like to invite?',
  'Folder Name': 'Folder Name',
  'Pedigree Name': 'Pedigree Name',
  'Sex': 'Sex',
  'Email': 'Email',
  'Failed to get folders': 'Failed to get folders',
  'Female': 'Female',
  'Male': 'Male',
  'Enter additional data': 'Enter additional data',
  'Next': 'Next',
  'Failed to check questionnaires': 'Failed to check questionnaires',
  'differentQuestionnairesError': 'You can only send reminders for one questionnaire at a time. Please limit your selection to people who have been sent the same questionnaire.',
  'There is a problem with the email addresses for the selected invites': 'There is a problem with the email addresses for the selected invites',
  'Please enter valid email addresses and resend the invitations': 'Please enter valid email addresses and resend the invitations',
  'Invitations were not sent to the following individuals': 'Invitations were not sent to the following individuals',
  'Invites': 'Invites',
  'Select Questionnaire': 'Select Questionnaire',
  'Invite Statu': 'Invite Statu',
  'Invited By': 'Invited By',
  'Invited Within': 'Invited Within',
  'Started Within': 'Started Within',
  'Completed Within': 'Completed Within',
  'Days': 'Days',
  'Weeks': 'Weeks',
  'Failed to get questionnaires': 'Failed to get questionnaires',
  'invite_CREATED': 'Invite Created',
  'invite_SENT': 'Invite Sent',
  'invite_PARTIALLY_COMPLETED': 'Questionnaire Partially Completed',
  'invite_COMPLETED': 'Questionnaire Completed',
  'invite_DECLINED': 'Invite Declined',
  'invite_REMINDER_SENT': 'Reminder Sent',
  'invite_COMPLETED_MANUALLY': 'Completed Manually',
  'invite_INACTIVE': 'Inactive',
  'invite_REVIEWED': 'Reviewed',
  'Failed to get invited by list': 'Failed to get invited by list',
  'Failed to get invites filter': 'Failed to get invites filter',
  'Invite Patient to Complete a Questionnaire': 'Invite Patient to Complete a Questionnaire',
  'Previous': 'Previous',
  'Send an Invite': 'Send an Invite',
  'The Questionnaire invitation emails were successfully submitted': 'The Questionnaire invitation emails were successfully submitted',
  'individualMovePedigreeMsg': 'The individual you selected must be moved to a new pedigree in order to send a Family History Questionnaire.',
  'There no individuals to display': 'There no individuals to display',
  'Failed to load individuals history': 'Failed to load individuals history',
  'Select Individuals To Invite': 'Select Individuals To Invite',
  'Export': 'Export',
  'Export Data': 'Export Data',
  'Settings': 'Settings',
  'Text (Tab Delimited)': 'Text (Tab Delimited)',
  'Text (Comma Delimited)': 'Text (Comma Delimited)',
  'Text (Other)': 'Text (Other)',
  'Excel (xls)': 'Excel (xls)',
  'Excel (xlsx)': 'Excel (xlsx)',
  'Options': 'Options',
  'Include Column Headings': 'Include Column Headings',
  'Delimiter': 'Delimiter',
  'Failed to export invites data': 'Failed to export invites data',
  'Loading': 'Loading',
  'Query Format': 'Query Format',
  'Load': 'Load',
  'New Folder': 'New Folder',
  'Delete Folder': 'Delete Folder',
  'Delete Format': 'Delete Format',
  'Search for Spreadsheets': 'Search for Spreadsheets',
  'Format Name': 'Format Name',
  'Description': 'Description',
  'No data': 'No data',
  'No folders': 'No folders',
  'Failed to get query management folders': 'Failed to get query management folders',
  'Failed to get query management formats': 'Failed to get query management formats',
  'Load Query': 'Load Query',
  'Failed to load individual history logs': 'Failed to load individual history logs',
  'History Log': 'History Log',
  'No history logs': 'No history logs',
  'Status': 'Status',
  'nameOfExistingPedigree': 'What is the Name of the Existing Pedigree From Which To Invite Individuals?',
  'selectExistOrNewQuery': 'Select an existing query or new query format to search for Individuals',
  'reviewEditQueryIndividuals': 'Review/Edit Query To Search For Individuals',
  'nameOfExistingPedigree': ' What is the Name of the Existing Pedigree From Which To Invite Individuals? ',
  'Failed to create format folder' : 'Failed to create format folder',
  'Are you sure you want to delete the selected format?': 'Are you sure you want to delete the selected format?',
  'Are you sure you want to delete the selected folder?': 'Are you sure you want to delete the selected folder?',
  'Failed to delete formats folder': 'Failed to delete formats folder',
  'Folder successfully deleted': 'Folder successfully deleted',
  'Failed to delete format': 'Failed to delete format',
  'Format successfully deleted': 'Format successfully deleted',
  'New Query': 'New Query',
  'Query': 'Query',
  'Query Formats': 'Query Formats',
  'Drag Fields From Warehouse And Drop Here': 'Drag Fields From Warehouse And Drop Here',
  'Cancel': 'Cancel',
  'Apply': 'Apply',
  'Failed to load folders': 'Failed to load folders',
  'Failed to load format': 'Failed to load format',
  'Are you sure you wish to remove all query clauses?': 'Are you sure you wish to remove all query clauses?',
  'Failed to get query management folder fields': 'Failed to get query management folder fields',
  'Edit Query': 'Edit Query',
  'Clear': 'Clear',
  'Edt': 'Edt',
  'Failed to create pedigree': 'Failed to create pedigree',
  'Failed to update details': 'Failed to update details',
  'Failed to send an invite': 'Failed to send an invite',
  'Failed to get additional data': 'Failed to get additional data',
  'Failed to update individual': 'Failed to update individual',
  'Failed to get individual data': 'Failed to get individual data',
  'Please provide first name, last name and email': 'Please provide first name, last name and email',
  'Please provide a valid email': 'Please provide a valid email',
  'Individual name': 'Individual name',
  'First name': 'First name',
  'Last name': 'Last name',
  'Phone number': 'Phone number',
  'Email': 'Email',
  'Pass code': 'Pass code',
  'You cannot invite some of selected individual(s) to a Family History Questionnaire': 'You cannot invite some of selected individual(s) to a Family History Questionnaire',
  'selectIndividualForSendInvite': 'Please select an individual this is not in a pedigree or is the only member of a pedigree or is proband',
  'This problem applies to the following individual(s)': 'This problem applies to the following individual(s)',
  'Failed to check individual': 'Failed to check individual',
  "Selected questionnaire doesn't have Datasheet Format": "Selected questionnaire doesn't have Datasheet Format",
  "The Pedigree Name you entered is already used in this database, please choose another name": "The Pedigree Name you entered is already used in this database, please choose another name",
  'Failed to get query format': 'Failed to get query format',
  'Failed to save query format': 'Failed to save query format',
  'Please review': 'Please review',
  'alreadyExistsFormatInTheSpecifiedFolder': "Spreadsheet format with the name '{oldFormatName}' already exists in the specified folder. Would you like to rename it to '{newFormatName}'?",
  'Enter New Format Name': 'Enter New Format Name',
  'Enter New Format Description': 'Enter New Format Description',
};